export type StorageType = 'localStorage' | 'sessionStorage'

const getStorage = function (type: StorageType = 'localStorage'): Storage | null {
    if (typeof window === 'undefined') {
        return null
    }

    try {
        return window[type] || null
    } catch (error) {
        return null
    }
}

const getItem = function (key: string, type: StorageType = 'localStorage'): string | null {
    const storage = getStorage(type)

    if (!storage) {
        return null
    }

    try {
        return storage.getItem(key)
    } catch (error) {
        return null
    }
}

const setItem = function (key: string, value: string, type: StorageType = 'localStorage'): boolean {
    const storage = getStorage(type)

    if (!storage) {
        return false
    }

    try {
        storage.setItem(key, value)
        return true
    } catch (error) {
        return false
    }
}

const removeItem = function (key: string, type: StorageType = 'localStorage'): boolean {
    const storage = getStorage(type)

    if (!storage) {
        return false
    }

    try {
        storage.removeItem(key)
        return true
    } catch (error) {
        return false
    }
}

const clear = function (type: StorageType = 'localStorage'): boolean {
    const storage = getStorage(type)

    if (!storage) {
        return false
    }

    try {
        storage.clear()
        return true
    } catch (error) {
        return false
    }
}

export default {
    getItem,
    setItem,
    removeItem,
    clear,
    // Callers know the shape they persisted: `get<CurrentUser>('auth.currentUser')`.
    get<T = unknown>(key: string, type: StorageType = 'localStorage'): T | null {
        const value = getItem(key, type)

        if (!value) {
            return null
        }

        try {
            return JSON.parse(value) as T
        } catch (error) {
            return null
        }
    },
    save(key: string, state: unknown, type: StorageType = 'localStorage'): boolean {
        return setItem(key, JSON.stringify(state), type)
    },
    delete(key: string, type: StorageType = 'localStorage'): boolean {
        return removeItem(key, type)
    },
}
